<template>
  <div class="relative" v-if="!selectedStoreId && stores.length > 1">
    <div v-if="selectedStores.length > 0" class="absolute -top-2 -right-2 z-10">
      <span class="inline-flex items-center px-2 py-1 rounded-full text-xs font-medium bg-primary text-white">
        {{ selectedStores.length }}
      </span>
    </div>
    <MultiSelectSearch
      :search-groups="searchGroups"
      placeholder="Rechercher un point de vente..."
      :input-id="'analytics-search'"
      :min-search-length="0"
      :debounce-delay="100"
      :show-component="stores.length > 1"
      :initial-selections="initialSelections"
      :icon="OfficeBuildingIcon"
      @update-selections="handleUpdateSelections"
      @search="handleSearch"
      @toggle-item="handleToggleItem"
    />
  </div>
</template>

<script>
import { MultiSelectSearch } from "@estaly/ui";
import { OfficeBuildingIcon } from "@heroicons/vue/outline";
import { mapState, mapGetters } from "vuex";

export default {
  name: "AnalyticsSelector",
  components: {
    MultiSelectSearch,
  },
  emits: ["select-store", "update-selections"],

  created() {
    this.OfficeBuildingIcon = OfficeBuildingIcon;
  },

  data() {
    return {
      selectedStores: [],
      storesResults: [],
    };
  },
  computed: {
    ...mapState("store", { stores: "index" }),
    ...mapGetters("store", ["selectedStoreId"]),

    searchGroups() {
      return [
        {
          key: "stores",
          label: "Points de vente",
          items: this.storesResults,
          getDisplayName: (store) => store.salesChannel,
          isSelected: (storeId) => this.selectedStores.some((store) => store.id === storeId),
        },
      ];
    },

    initialSelections() {
      return {
        stores: this.selectedStores,
      };
    },
  },
  mounted() {
    this.storesResults = [...this.stores];
  },
  methods: {
    handleSearch(keywords) {
      if (!keywords || keywords.trim() === "") {
        this.storesResults = [...this.stores];
      } else {
        this.storesResults = this.stores.filter((store) =>
          store.salesChannel.toLowerCase().includes(keywords.toLowerCase()),
        );
      }
    },

    handleToggleItem({ item, groupKey }) {
      if (groupKey === "stores") {
        const index = this.selectedStores.findIndex((s) => s.id === item.id);
        if (index >= 0) {
          this.selectedStores.splice(index, 1);
        } else {
          this.selectedStores.push(item);
        }
      }
      this.emitSelections();
    },

    handleUpdateSelections(selections) {
      this.selectedStores = selections.stores || [];
      this.emitSelections();
    },

    emitSelections() {
      this.$emit("update-selections", {
        stores: this.selectedStores,
      });
    },
  },
};
</script>
